import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = { class: "fancy-button__icon" }

import { toRefs } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    color: { default: 'green' }
  },
  setup(__props: any) {

const props = __props as { title: string, color: string }

    

    const { title, color } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(['fancy-button', `fancy-button--${_unref(color)}`])
  }, [
    _createElementVNode("span", {
      class: "fancy-button__text",
      textContent: _toDisplayString(_unref(title))
    }, null, 8, _hoisted_1),
    _createElementVNode("span", _hoisted_2, [
      _renderSlot(_ctx.$slots, "icon")
    ])
  ], 2))
}
}

})